<template>
  <v-layout column>
    <v-layout row>
      <v-layout class="small-book-form" pl-1 xs12 row wrap align-start>
        <v-flex shrink pt-2 pr-3>
          <h5 style="padding-right: 12px;">{{title}}</h5>
        </v-flex>
        <p style="color: red;" v-if="error != null">{{error}}&nbsp;</p>
        <v-flex pr-2 xs4 lg2 class="trip-duration-form trip-duration-form-a">
          <BookingDateInput
            @input="function() {bookingForm.updateDate(); lastTime = null;}"
            label="Start Date"
            v-model="repeatTripDefinition.date_span.start_date"
          ></BookingDateInput>
        </v-flex>
        <v-flex pl-2 xs4 lg2 class="trip-duration-form trip-duration-form-b">
          <BookingDateInput
            @input="function() {bookingForm.updateDate(); lastTime = null;}"
            label="Finish Date"
            v-model="repeatTripDefinition.date_span.end_date"
          ></BookingDateInput>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-flex pr-2 pt-2>
      <v-layout row>
        <v-divider style="margin-left: 12px; margin-top: 2px; margin-bottom: 5px;"></v-divider>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import BookingDateInput from "@/components/widget/input/BookingDateInput.vue";
import SimpleNumberInput from "@/components/widget/input/SimpleNumberInput.vue";
import BookTripETARoute from "@/components/widget/input/BookTripETARoute.vue";

import { RepeatService } from "@/components/util/RepeatService.js";

export default {
  name: "trip_duration_form",
  components: {
    BookingDateInput,
    SimpleNumberInput,
    BookTripETARoute
  },
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    title: String,
    content: String,
    label: { type: String, default: "Service Duration" },
    error: String,
    repeatTripDefinition: Object,
    bookingForm: Object
  },
  data() {
    return {
      menu: false,
      skipWeekends: false,
      same: true
    };
  },

  methods: {
    updateTripATimes(text) {
      this.updateTripTimesSame(
        text,
        this.repeatService.repeatServiceModel.trip_a.day_of_week_times_list
      );
    },
    updateTripBTimes(text) {
      this.updateTripTimesSame(
        text,
        this.repeatService.repeatServiceModel.trip_b.day_of_week_times_list
      );
    },
    updateTripTimesSame(text, dayOfWeekTimesList) {
      if (!this.same) {
        return;
      }

      dayOfWeekTimesList[0].time = text;
      dayOfWeekTimesList[1].time = text;
      dayOfWeekTimesList[2].time = text;
      dayOfWeekTimesList[3].time = text;
      dayOfWeekTimesList[4].time = text;

      if (this.skipWeekends) {
        return;
      }

      dayOfWeekTimesList[5].time = text;
      dayOfWeekTimesList[6].time = text;
    },
    disableWeekend(index) {
      console.log(index);
      return index >= 5 && this.skipWeekends;
    },
    changeSkipWeekends(skip) {
      console.log(skip);
      this.skipWeekends = skip;

      if (skip) {
        if (this.repeatService.repeatServiceModel.trip_a != null) {
          this.repeatService.repeatServiceModel.trip_a.day_of_week_times_list[5].time = null;
          this.repeatService.repeatServiceModel.trip_a.day_of_week_times_list[6].time = null;
        }

        if (this.repeatService.repeatServiceModel.trip_b != null) {
          this.repeatService.repeatServiceModel.trip_b.day_of_week_times_list[5].time = null;
          this.repeatService.repeatServiceModel.trip_b.day_of_week_times_list[6].time = null;
        }
      } else {
        this.repeatService.repeatServiceModel.trip_a.day_of_week_times_list[5].time =
          "09:00";
        this.repeatService.repeatServiceModel.trip_a.day_of_week_times_list[6].time =
          "09:00";

        if (this.repeatService.repeatServiceModel.trip_b != null) {
          this.repeatService.repeatServiceModel.trip_b.day_of_week_times_list[5].time =
            "09:00";
          this.repeatService.repeatServiceModel.trip_b.day_of_week_times_list[6].time =
            "09:00";
        }
      }
    },
    changeSame(same) {
      this.same = same;
    },
    valid() {
      console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    updateSelf(content) {
      this.menu = false;
      this.$emit("input", content);
      this.$emit("submitted");
      console.log("date selected");
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  color: #10425a;
}

.bottom-trip-info {
  background-color: #cccccc;
  height: 28px;
  min-height: 28px !important;
  border-radius: 8px;
  padding-left: 18px;
  padding-right: 18px;
  font-weight: 500;
  font-size: 12px;
}

.small-button {
  font-size: 12px !important;
}

.trip-duration-form .theme--light.v-label {
  font-weight: 500 !important;
  font-size: 16px !important;
}

.trip-duration-form-a .theme--light.v-label {
  color: green !important;
}

.trip-duration-form-b .theme--light.v-label {
  color: red !important;
}
</style>
